import { styled } from "@mui/material/styles";
import { Link } from "@mui/material";
import { myVJBlue100 } from "../../constants/brandingColors";
import { ReactComponent as GreaterThanIcon } from "../../loginImages/greater-than.svg";

const LinkArrow = styled(GreaterThanIcon)(({ theme }) => ({
  marginLeft: theme.spacing(1),
  height: '11px',
  width: '11px',
  flexShrink: 0,
  color: myVJBlue100,
}));

interface LoginLinkProps {
  text?: string;
  target?: string;
  href?: string;
  onClick?;
}

const PrimaryLink = ({
  text = '',
  target = "self",
  href,
  onClick
}: LoginLinkProps) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <Link
        component="a"
        variant="subtitle1"
        target={target}
        href={href}
        onClick={onClick}
      >
        {text}
      </Link>
      <LinkArrow />
    </div>
  );
};

export default PrimaryLink